function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.387%",
  y1: "42.979%",
  x2: "90.038%",
  y2: "65.034%",
  id: "profile-card-success_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD98A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "29.837%",
  y1: "40.824%",
  x2: "100%",
  y2: "70.681%",
  id: "profile-card-success_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE852A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.477%",
  y1: "33.027%",
  x2: "89.776%",
  y2: "86.347%",
  id: "profile-card-success_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD98A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "29.97%",
  y1: "27.816%",
  x2: "99.672%",
  y2: "100%",
  id: "profile-card-success_svg__d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE852A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "29.837%",
  y1: "43.92%",
  x2: "100%",
  y2: "63.702%",
  id: "profile-card-success_svg__e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE852A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.387%",
  y1: "49.485%",
  x2: "90.038%",
  y2: "51.103%",
  id: "profile-card-success_svg__f"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD98A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.387%",
  y1: "49.659%",
  x2: "90.038%",
  y2: "50.729%",
  id: "profile-card-success_svg__g"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD98A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.387%",
  y1: "48.137%",
  x2: "90.038%",
  y2: "53.99%",
  id: "profile-card-success_svg__h"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD98A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.387%",
  y1: "48.334%",
  x2: "90.038%",
  y2: "53.567%",
  id: "profile-card-success_svg__i"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD98A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: ".005%",
  y1: "50.047%",
  x2: "99.891%",
  y2: "50.047%",
  id: "profile-card-success_svg__j"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4543C",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F45D43",
  offset: "24%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F67755",
  offset: "64%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F67D5A",
  offset: "73%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 15.79)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.16 15.095C18.397 17.182 12.22 40.97 19.68 66.081c7.463 25.112 36.381 16.21 51.95 19.883 15.567 3.672 45.565-1.26 45.565-23.226 0-21.966-15.192-9.825-21.03-29.777C90.327 13.01 69.925 13.01 44.16 15.095z",
  fill: "#FFEFDB"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#F1823B",
  fillRule: "nonzero",
  cx: 123.181,
  cy: 71.997,
  rx: 2.955,
  ry: 2.915
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FDB913",
  fillRule: "nonzero",
  cx: 129.09,
  cy: 58.676,
  rx: 5.91,
  ry: 5.829
}), /*#__PURE__*/React.createElement("path", {
  d: "M.773 25.22l3.437-3.39a1.07 1.07 0 011.503 0l3.438 3.39a1.07 1.07 0 010 1.524l-3.438 3.39a1.07 1.07 0 01-1.503 0l-3.437-3.39a1.07 1.07 0 010-1.524z",
  fill: "#FDB913",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.896 1.906l1.79 4.06 3.777 2.057a.888.888 0 01.002 1.558l-3.78 2.066-1.625 4a.888.888 0 01-1.62.054l-1.838-3.769-3.971-2.18a.888.888 0 01-.008-1.552l3.979-2.235 1.662-4.038a.888.888 0 011.632-.02zM10.979 76.92l1.143 2.595 2.501 1.361a.888.888 0 01.001 1.558l-2.502 1.369-1.043 2.566a.888.888 0 01-1.62.055l-1.173-2.406-2.653-1.457a.888.888 0 01-.008-1.552l2.661-1.494 1.06-2.575a.888.888 0 011.633-.02z",
  fill: "#FE9824"
})), /*#__PURE__*/React.createElement("path", {
  d: "M109.97 41.407V77.91c0 3.183-2.572 5.763-5.745 5.763H41.033c-3.172 0-5.744-2.58-5.744-5.763V41.407c0-.322.028-.644.086-.96a5.75 5.75 0 015.658-4.804h63.192c3.173 0 5.745 2.58 5.745 5.764z",
  fill: "url(#profile-card-success_svg__a)"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#profile-card-success_svg__b)",
  x: 25.714,
  y: 45.249,
  width: 74.681,
  height: 48.03,
  rx: 6.943
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#profile-card-success_svg__c)",
  x: 61.14,
  y: 52.934,
  width: 32.553,
  height: 32.66,
  rx: 2.314
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "url(#profile-card-success_svg__d)",
  cx: 77.416,
  cy: 63.366,
  rx: 4.893,
  ry: 4.909
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.12 80.071H68.713a1.31 1.31 0 01-.99-.458 1.319 1.319 0 01-.302-1.05c.65-4.803 3.772-7.781 8.368-8.972l1.302 1.306-1.302 6.552 1.627 1.642 1.628-1.642-1.302-6.552 1.302-1.306c4.596 1.191 7.717 4.178 8.368 8.972.056.377-.055.76-.303 1.05a1.31 1.31 0 01-.99.458z",
  fill: "url(#profile-card-success_svg__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.608 53.04c1 0 1.81.812 1.81 1.815 0 .892-.64 1.633-1.485 1.787l-.325.03H33.374c-1 0-1.81-.814-1.81-1.817 0-.891.64-1.633 1.484-1.787l.326-.029h17.234zm0 6.963c1 0 1.81.814 1.81 1.817 0 .891-.64 1.633-1.485 1.787l-.325.029H33.374c-1 0-1.81-.813-1.81-1.816 0-.892.64-1.634 1.484-1.787l.326-.03h17.234z",
  fill: "url(#profile-card-success_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.395 66.968c1 0 1.81.813 1.81 1.816 0 .892-.64 1.633-1.484 1.787l-.326.03H33.374c-1 0-1.81-.814-1.81-1.817 0-.892.64-1.633 1.484-1.787l.326-.03h22.021z",
  fill: "url(#profile-card-success_svg__g)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.395 73.932c1 0 1.81.813 1.81 1.816 0 .892-.64 1.633-1.484 1.787l-.326.03h-7.343c-1 0-1.81-.814-1.81-1.817 0-.891.64-1.633 1.484-1.787l.326-.029h7.343z",
  fill: "url(#profile-card-success_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.35 73.932c1 0 1.81.813 1.81 1.816 0 .892-.64 1.633-1.485 1.787l-.326.03h-7.975c-1 0-1.81-.814-1.81-1.817 0-.891.64-1.633 1.484-1.787l.326-.029h7.975z",
  fill: "url(#profile-card-success_svg__i)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.395 80.896c1 0 1.81.814 1.81 1.817 0 .891-.64 1.633-1.484 1.787l-.326.029h-7.343c-1 0-1.81-.813-1.81-1.816 0-.892.64-1.634 1.484-1.787l.326-.03h7.343z",
  fill: "url(#profile-card-success_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.35 80.896c1 0 1.81.814 1.81 1.817 0 .891-.64 1.633-1.485 1.787l-.326.029h-7.975c-1 0-1.81-.813-1.81-1.816 0-.892.64-1.634 1.484-1.787l.326-.03h7.975z",
  fill: "url(#profile-card-success_svg__i)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(82.135)"
}, /*#__PURE__*/React.createElement("ellipse", {
  fill: "url(#profile-card-success_svg__j)",
  fillRule: "nonzero",
  cx: 24.825,
  cy: 25.026,
  rx: 24.825,
  ry: 25.026
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 5.427,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14.293 25.026l7.966 7.584 14.603-15.168"
})));

function SvgProfileCardSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 104,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgProfileCardSuccess;